module.exports = __webpack_public_path__ + "img/p-one-step-10.390c4548.png";